// src/app/bilgiSayfasiUrl.ts
//
// ANLATIM YÜZEYLERİNİN URL ŞEMASI — TEK KAYNAK (SAF).
//
// 🩺 Kapatılan kusur (kanonun kalıcı URL kuralı, CLAUDE.md "🔗 KALICI KURAL"):
// ürünün ana anlatım yüzeyleri — `StarInfoSheet` (5★ nedir), `GoldInfoSheet`
// (Gold Star), `MyCardsInfoSheet`, `StarJourneySheet` (yıldız yolculuğu) —
// dördü de `pushState`/`replaceState` İÇERMİYORDU. Yani "MyLASA yıldızı
// nedir?" sorusuna link atılamıyordu: ürünün kendi hikâyesi paylaşılamayan
// bir yüzeydi. Kanon (`MYLASA_MAIN_LOOP_CANON.md`) bu yüzeyleri ana döngünün
// anlatımı sayar; paylaşılamayan anlatım, yayılamayan üründür.
//
// ŞEMA: `/info/{konu}` — İKİ SEGMENT.
//   Bilerek iki segment: çıplak profil matcher'ı (`/{kullaniciAdi}`) yalnız
//   tek segmenti (+ bilinen profil alt-yollarını) tanır, dolayısıyla
//   `/info/star` bir kullanıcı adıyla ASLA çakışamaz.
//   Kök segment "info" ayrıca `ROUTER_REZERVE`ye eklendi; "info" ZATEN
//   `KAYIT_BLOCKLIST`te olduğu için `TUM_REZERVE` birleşimi DEĞİŞMEDİ →
//   `firestore.rules` ve `functions/src/auth.ts` kopyaları da değişmedi
//   (`reservedUsernames.test.ts` eşitliği korunur).

const BILGI_KOK = "/info";

/** Şemanın tanıdığı konular. Yeni sheet eklenirse BURAYA eklenir. */
export const BILGI_KONULARI = ["star", "gold", "mycards", "journey"] as const;

export type BilgiKonusu = (typeof BILGI_KONULARI)[number];

const KONU_KUMESI: ReadonlySet<string> = new Set<string>(BILGI_KONULARI);

/** Konu → canonical yol. Geçersiz konu → null (uydurma yol üretilmez). */
export function bilgiYolu(konu: string | null | undefined): string | null {
  const k = String(konu || "").trim().toLowerCase();
  return KONU_KUMESI.has(k) ? `${BILGI_KOK}/${k}` : null;
}

/**
 * Yol → konu (soğuk yük). Trailing-slash toleranslı (mPost/mClip ile hizalı).
 * Tanınmayan konu → null: `/info/uydurma` bir anlatım yüzeyi AÇMAZ, çözücü
 * `false` döner ve yol normal "çözülemedi" davranışına düşer.
 */
export function yoldanBilgi(path: string | null | undefined): BilgiKonusu | null {
  const m = String(path || "").match(/^\/info\/([^/]+)\/?$/);
  if (!m) return null;
  let konu: string;
  try {
    konu = decodeURIComponent(m[1]);
  } catch {
    konu = m[1];
  }
  konu = konu.trim().toLowerCase();
  return KONU_KUMESI.has(konu) ? (konu as BilgiKonusu) : null;
}

/** Şu an bir anlatım yüzeyi yolunda mıyız? (kapanış kararı için) */
export function bilgiYolundaMi(path: string | null | undefined): boolean {
  return yoldanBilgi(path) !== null;
}
